import {
  EuiHeader,
  EuiHeaderSection,
  EuiHeaderSectionItem,
} from "@inscopix/ideas-eui";
import "./AppHeader.scss";
import AppName from "../AppName/AppName";
import { PopoverFileUpload } from "components/PopoverFileUpload/PopoverFileUpload";
import { UserMenu } from "components/UserMenu/UserMenu";
import { Notifications } from "components/Notifications/Notifications";
import { HelpMenu } from "./HelpMenu";
import { useAppHeader } from "../../providers/AppHeaderProvider";
import { HeaderTours } from "components/HeaderTours/HeaderTours";

/**
 * Top-level header for pages
 * Displays logo by default
 * Displays custom content & navigation if provided
 */

function AppHeader() {
  const defaultContent = (
    <EuiHeaderSection>
      <AppName />
    </EuiHeaderSection>
  );
  const { nav, content } = useAppHeader();
  const headerContent = content !== undefined ? content : defaultContent;
  return (
    <>
      <EuiHeader theme="dark" position="fixed">
        {nav !== undefined ? (
          <EuiHeaderSection grow={false} className="app-header-nav">
            {nav}
          </EuiHeaderSection>
        ) : null}
        {headerContent}
        <EuiHeaderSection grow={false} style={{ flexShrink: 0 }}>
          <EuiHeaderSectionItem>
            <PopoverFileUpload />
          </EuiHeaderSectionItem>
          <EuiHeaderSectionItem>
            <Notifications />
          </EuiHeaderSectionItem>
          <EuiHeaderSectionItem>
            <HelpMenu />
          </EuiHeaderSectionItem>
          <EuiHeaderSectionItem>
            <HeaderTours />
          </EuiHeaderSectionItem>
          <div style={{ paddingRight: 8 }}></div>
          <UserMenu />
        </EuiHeaderSection>
      </EuiHeader>
    </>
  );
}

export default AppHeader;
